function getIsTgAuth() {
    return !!window.Telegram?.WebApp?.initData;
}

export default getIsTgAuth;
